// extracted by mini-css-extract-plugin
module.exports = {"chartCard":"index-module--chartCard--1QUu0"};